import React, { ReactElement } from "react";
import Background from "../../Components/Background";

export default function CreatePatient(): ReactElement {
  return <Background elements={[]} header="Create Patient" />;
}
